import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import AppRoutes from './routes';
import 'bootstrap-icons/font/bootstrap-icons.css'; // ← importa os ícones
import 'aos/dist/aos.css';
import AOS from 'aos';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


AOS.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRoutes />
  </React.StrictMode>
);
